import React from "react";
import { useParams } from "react-router-dom";
import useTeamApi from "../hooks/use-team-api";

const TeamContext = React.createContext();
TeamContext.displayName = "TeamContext";

const TeamProvider = (props) => {
    const { teamId } = useParams();

    const teamApi = useTeamApi(teamId);

    return <TeamContext.Provider value={teamApi} {...props} />;
};

const useTeam = () => {
    const context = React.useContext(TeamContext);
    if (context === undefined) {
        throw new Error(`useTeam must be used within a TeamContext`);
    }
    return context;
};

export { TeamProvider, useTeam };
